import styles from './RowSelection.module.css';

export interface SelectionAnnouncerProps {
    /** `selection.announcement` — the last change, in one sentence; `''` until the first. */
    readonly message: string;
    readonly 'data-testid'?: string;
}

/**
 * The selection's one visually hidden `role="status"` line (F5-h WI-1.3). A consumer renders it in
 * every state of its list, beside its own status line, because a live region created alongside its
 * content is never announced (forge-et-fe `CLAUDE.md` § Conventions). It carries each change —
 * `3 accounts selected`, `Selection cleared` — so the bar's own count need not be live.
 */
export function SelectionAnnouncer({ message, 'data-testid': testId }: SelectionAnnouncerProps) {
    return (
        <p className={styles.visuallyHidden} data-testid={testId} role="status">
            {message}
        </p>
    );
}
